import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import TextArea from '../UI/Control/InputTextarea';
import { useSelector } from 'react-redux'
import MandatoryLabel from '../UI/Control/MandatoryLabel';
const DefaultActionProcess = (props) => {

    let taskId = props.taskId;
    const EDCUserID = useSelector(state => state.auth.gValue01);

    const SaveDefaultActionProcess = (event) => {

        let objNotes = document.getElementById('txtNotes');
        if (props.actionName.toLowerCase() == 'query resolved') {
            if (props.Type.toLowerCase() != 'cims' && props.Type.toLowerCase() != 'cims-zelta' && objNotes.value.trim() == '') {
                alert('Notes should not be empty.');
                objNotes.focus();
                return false;
            }
        }
        else {
            if (objNotes.value.trim() == '') {
                alert('Notes should not be empty.');
                objNotes.focus();
                return false;
            }
        }

        let model = {
            TaskID: taskId,
            Notes: objNotes.value,
            CreationUser: EDCUserID,
            ActionName: props.actionName
        };

        fetch('api/ImageService/SaveDefaultActionProcess', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(model)
        }).then(r => r.json()).then(res => {
            if (res == -1) {
                alert('Notes not saved, Something went wrong.');
            }
            if (res > 0) {
                props.relaodAction();
            }
        })
    };

    return (
        <div>
            <Row className="mt-2 mb-2">
                <Col md={1}>Action Notes
                    {(props.actionName.toLowerCase() == 'query resolved' && (props.Type.toLowerCase() == 'cims' || props.Type.toLowerCase() == 'cims-zelta')) == false && < MandatoryLabel ></MandatoryLabel>}
                    : </Col>
                <Col md={10}>
                    <TextArea id="txtNotes" rows='5' cols='100' />
                </Col>
                <Col md={1}><Button style={{ marginTop: "90px" }} className="btn-success" onClick={SaveDefaultActionProcess} > Submit </Button></Col>
            </Row>
        </div>
    );
}
export default DefaultActionProcess;
